import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, RawButton, Text, useResponsive } from '@common-fe/common-fe';

import ConfirmCancelModal from '../ConfirmCancelModal';

interface Props {
  onCancel: () => void;

  isBillPayMode?: boolean;
}
const CancelClaimButton: React.FC<Props> = ({ onCancel, isBillPayMode = false }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const [confirmCancelVisible, setConfirmCancelVisible] = useState(false);
  return (
    <>
      <ConfirmCancelModal
        visible={confirmCancelVisible}
        onSetVisible={setConfirmCancelVisible}
        onSubmit={onCancel}
        {...(isBillPayMode
          ? {
              header: t('Cancel Bill Pay?'),
              submitButtonTitle: t('Yes, Cancel Bill Pay'),
            }
          : {
              header: t('Cancel reimbursement?'),
              submitButtonTitle: t('Yes, Cancel Reimbursement'),
            })}
      />
      {isMobile ? (
        <RawButton data-testId="cancel_button" onClick={() => setConfirmCancelVisible(true)}>
          <Box align="center" justify="center">
            <Text size="small" color="danger">
              {t('Cancel')}
            </Text>
          </Box>
        </RawButton>
      ) : (
        <AppButton
          testId="cancel"
          onClick={() => setConfirmCancelVisible(true)}
          width="120px"
          buttonType="tertiary"
          color="red"
        >
          {t('Cancel')}
        </AppButton>
      )}
    </>
  );
};

export default CancelClaimButton;
